import "./ProfessionalPartners.module.css";
import Header from "@/reusable_sections/Header";
import Referrals from "./sections/Referrals";
import Standards from "./sections/Standards";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function ProfessionalPartnersPage() {
  return <div>
      <Header />
      <Referrals />
      <Standards />
      <Inquiry />
      <Footer />
    </div>;
}